import React, { forwardRef } from "react";
import { WORD_MISK, WORD_CARGO } from "./wordmark";

/* The Misk Cargo mark, rebuilt as geometry from the master artwork:
   a hexagonal "M" (the warehouse / route) holding a dark box (the parcel).
   Coordinates share the master's 1847×775 space so mark and wordmark align. */
export const HEX_PATH = "M335 1L665 192L665 580L575 632L575 247L335 386L95 247L95 632L5 580L5 192Z";
export const BOX_PATH = "M188 410L335 495L482 410L482 687L335 773L188 687Z";

const TONES = {
  // On light backgrounds: the exact brand colours.
  light: { hex: "#2C4824", box: "#211D22", misk: "#211D22", cargo: "#2C4824" },
  // On forest / near-black backgrounds: lifted for contrast, same identity.
  dark: {
    hex: "oklch(0.7 0.14 136)",
    box: "oklch(0.97 0.008 135)",
    misk: "oklch(0.97 0.008 135)",
    cargo: "oklch(0.8 0.13 134)",
  },
};

/**
 * @param {"light"|"dark"} tone   background the logo sits on
 * @param {boolean} markOnly       render the symbol without the wordmark
 */
const Logo = forwardRef(function Logo(
  { tone = "light", markOnly = false, className = "", title = "Misk Cargo", ...rest },
  ref,
) {
  const c = TONES[tone] || TONES.light;
  return (
    <svg
      ref={ref}
      viewBox={markOnly ? "0 0 672 776" : "0 0 1847 776"}
      className={`mk-logo ${className}`}
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g className="mk-mark">
        <path className="mk-hex" d={HEX_PATH} fill={c.hex} />
        <path className="mk-box" d={BOX_PATH} fill={c.box} />
      </g>
      {!markOnly && (
        <g className="mk-word">
          <g className="mk-word-misk" transform="translate(700 150)">
            <path d={WORD_MISK} fill={c.misk} fillRule="evenodd" />
          </g>
          <g className="mk-word-cargo" transform="translate(700 380)">
            <path d={WORD_CARGO} fill={c.cargo} fillRule="evenodd" />
          </g>
        </g>
      )}
    </svg>
  );
});

export default Logo;
